import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

export {
  TransactionDate,
  TransactionDateAndTime,
  TransactionTime,
} from '../loyalty-history/loyalty-history.styled';

export const StyledCurrency = makeUclComponent(Currency).withConfig({
  isBold: false,
});

type IconWrapperProps = BoxProps & {
  $pointsEarned: boolean;
};

const styles = StyleSheet.create({
  purchaseAmount: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  rewards: {
    flex: 1,
    paddingHorizontal: spacing.$1,
  },
  rewardsDesktop: {
    paddingHorizontal: spacing.$10,
  },
  iconWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  pointsLineWrapper: {
    flexDirection: 'column',
    width: '100%',
  },
  pointsDescription: {
    fontWeight: 'normal',
    minWidth: 128,
  },
});

export const PurchaseAmount = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.purchaseAmount, style] });

export const Rewards = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.rewards, isDesktop && styles.rewardsDesktop, style],
  });
};

export const StyledPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$4',
});

export const PointsText = withTypography({ fontSize: 'md', bold: true, ml: '$1' });

export const IconWrapper = ({ $pointsEarned: _pointsEarned, style, ...props }: IconWrapperProps) =>
  React.createElement(Box, { ...props, style: [styles.iconWrapper, style] });

export const PointsLineWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pointsLineWrapper, style] });

export const PointsDescription = withTypography({
  fontSize: 'sm',
  style: styles.pointsDescription,
});
